
const VocabLandingPage = {
    'brand': ['MedCleir'],
    'motto' : ['Contigo de la mano','Availability'],
    'patients' : ['Pacientes','Patients'],
    'profiessionals' : ['Profesionales','Professionals'],
    'jump_in' : ['Ingresar', 'Jump in'],
    'about' : ['Nosotros', 'About'],
    'searchbar_placeholder' : ['Buscar un médico, especialidad o servicio...', 'Search for a doctor, specialty, or service...'],
    'select_city_placeholder': ['Selecciona una ciudad','Select a city'],

    '' : ['', ''],
  }
  export default VocabLandingPage;
    